import './ox-scene-property.js'

import { LitElement, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'

@customElement('ox-scene-layer')
export default class OxSceneLayer extends LitElement {
  @property({ type: String }) type?: String
  @property({ type: String }) text?: String

  render() {
    return html` <slot select="ox-scene-property"></slot> `
  }

  getModel() {
    let model = {
      type: this.type
    }

    model = Array.from(this.querySelectorAll('ox-scene-property')).reduce((model: any, property: any) => {
      let value: any = property.value

      if (property.name) {
        switch (property.type) {
          case 'number':
            value = Number(value)
            break
          case 'boolean':
            value = Boolean(value)
            break
          default:
        }

        model[property.name] = value
      }

      return model
    }, model)

    return model
  }
}
